import { component } from 'picoapp';
import modifyCart from 'lib/modify-cart';

export default component(async (node) => {
  const form = node.querySelector<HTMLFormElement>('[data-form]');
  const btn = node.querySelector<HTMLElement>('[data-quickbuy-btn]');

  const init = () => {
    btn.addEventListener('click', () => {
      const btnWidth = btn.getBoundingClientRect().width;
      const btnHtml = btn.innerHTML;

      btn.style.width = `${btnWidth}px`;
      btn.innerHTML = theme.icons.loading;

      const formData = new FormData(form);

      modifyCart('add', formData, () => {
        btn.style.width = '';
        btn.innerHTML = btnHtml;
      });
    });
  };

  init();
});
